import { render, staticRenderFns } from "./note-viewer.vue?vue&type=template&id=788f7c99"
import script from "./note-viewer.vue?vue&type=script&lang=js"
export * from "./note-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('788f7c99')) {
      api.createRecord('788f7c99', component.options)
    } else {
      api.reload('788f7c99', component.options)
    }
    module.hot.accept("./note-viewer.vue?vue&type=template&id=788f7c99", function () {
      api.rerender('788f7c99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/conversation-list/note-viewer.vue"
export default component.exports